// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file consts/uiconfigconsts.proto (package aurora.core.consts.uiconfig, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file consts/uiconfigconsts.proto.
 */
export const file_consts_uiconfigconsts: GenFile = /*@__PURE__*/
  fileDesc("Chtjb25zdHMvdWljb25maWdjb25zdHMucHJvdG8SG2F1cm9yYS5jb3JlLmNvbnN0cy51aWNvbmZpZypaChJVSUNvbmZpZ1Zpc2liaWxpdHkSGgoWVU5TUEVDSUZJRURfVklTSUJJTElUWRAAEgsKB1BSSVZBVEUQARIMCghSRUFET05MWRACEg0KCVJFQURXUklURRADQilaJ2dpdGxhYi5wcnZibC5jb20vYXVyb3JhL2NvcmUvc3JjL2NvbnN0c2IGcHJvdG8z");

/**
 * @generated from enum aurora.core.consts.uiconfig.UIConfigVisibility
 */
export enum UIConfigVisibility {
  /**
   * @generated from enum value: UNSPECIFIED_VISIBILITY = 0;
   */
  UNSPECIFIED_VISIBILITY = 0,

  /**
   * @generated from enum value: PRIVATE = 1;
   */
  PRIVATE = 1,

  /**
   * @generated from enum value: READONLY = 2;
   */
  READONLY = 2,

  /**
   * @generated from enum value: READWRITE = 3;
   */
  READWRITE = 3,
}

/**
 * Describes the enum aurora.core.consts.uiconfig.UIConfigVisibility.
 */
export const UIConfigVisibilitySchema: GenEnum<UIConfigVisibility> = /*@__PURE__*/
  enumDesc(file_consts_uiconfigconsts, 0);

